import React from 'react';
import { Helmet } from 'react-helmet';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
interface PageTitleProps {
  title: string;
};

const PageTitle: React.FC<PageTitleProps> = ({ title = '' }) => {
  const { pageTitle } = useDocumentTitle({ title })

  const { generalConfig } = useSelector(
    (state: RootState) => state.configReducer,
  );
  return (
    <Helmet>
      <title>{pageTitle}</title>
      <link
        rel="icon"
        href={generalConfig?.staticImage?.favicon}
        type="image/svg+xml"
      />
    </Helmet>
  )
};

export default PageTitle;
